var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8269 4.07806C19.6192 2.97962 16.9177 2.3335 14 2.3335C11.0823 2.3335 8.38075 2.97962 6.17302 4.07806C5.09038 4.61673 4.54905 4.88607 4.02453 5.73291C3.5 6.57975 3.5 7.39972 3.5 9.03966V13.1101C3.5 19.7407 8.79942 23.4273 11.8685 25.0063C12.7245 25.4467 13.1524 25.6668 14 25.6668C14.8476 25.6668 15.2755 25.4467 16.1314 25.0063C19.2005 23.4273 24.5 19.7407 24.5 13.1101V9.03966C24.5 7.39973 24.5 6.57977 23.9755 5.73291C23.4509 4.88606 22.9096 4.61673 21.8269 4.07806Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.4168C10.5 13.4168 12.1425 13.7107 12.8333 15.7502C12.8333 15.7502 14.5833 12.2502 17.5 11.0835",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon);
export default __webpack_public_path__ + "static/media/FeatureIcon.3bd21007a0c91ae72147dba267ccca8c.svg";
export { ForwardRef as ReactComponent };